import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/blogs/components/BlogListClient.tsx");
